import {ActionType} from "../constants";

export function changeLocale(locale) {
    return {
        type: ActionType.CHANGE_LOCALE,
        locale
    };
}
